/* Novara — gallery, lightbox, tabs and variant switching.
   No dependencies. Re-initialises inside the theme editor. */
(function () {
  'use strict';

  /* ---------------------------------------------------------------- gallery */
  function initGallery(root) {
    if (root.dataset.nvReady) return;
    root.dataset.nvReady = 'true';

    var track = root.querySelector('.nv-gallery__track');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.nv-gallery__slide'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.nv-gallery__thumb'));
    var prev = root.querySelector('.nv-gallery__arrow--prev');
    var next = root.querySelector('.nv-gallery__arrow--next');
    var lightbox = root.querySelector('.nv-lightbox');
    var index = 0;

    if (!track || !slides.length) return;

    function goTo(i) {
      index = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft });
      sync();
    }

    function sync() {
      thumbs.forEach(function (thumb, i) {
        thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
      if (thumbs[index]) {
        thumbs[index].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }

    // Keep the active index in step when the person swipes.
    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var nearest = 0;
        var best = Infinity;
        slides.forEach(function (slide, i) {
          var distance = Math.abs(slide.offsetLeft - track.offsetLeft - track.scrollLeft);
          if (distance < best) { best = distance; nearest = i; }
        });
        index = nearest;
        sync();
      }, 80);
    });

    if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); });

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { goTo(i); });
    });

    if (lightbox) initLightbox(root, lightbox, function () { return index; }, goTo);

    sync();
  }

  /* --------------------------------------------------------------- lightbox */
  function initLightbox(root, lightbox, getIndex, setGalleryIndex) {
    var track = lightbox.querySelector('.nv-lightbox__track');
    var slides = Array.prototype.slice.call(lightbox.querySelectorAll('.nv-lightbox__slide'));
    var openers = Array.prototype.slice.call(root.querySelectorAll('[data-nv-lightbox-open]'));
    var lastFocused = null;
    var current = 0;

    function scrollToSlide(i) {
      current = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[current].offsetLeft, behavior: 'auto' });
    }

    function open(i) {
      lastFocused = document.activeElement;
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      // Layout must settle before we can scroll to the right slide.
      requestAnimationFrame(function () { scrollToSlide(i); });
      var close = lightbox.querySelector('.nv-lightbox__button--close');
      if (close) close.focus();
    }

    function close() {
      lightbox.hidden = true;
      document.body.style.overflow = '';
      setGalleryIndex(current);
      if (lastFocused) lastFocused.focus();
    }

    openers.forEach(function (opener, i) {
      opener.addEventListener('click', function () { open(i); });
    });

    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox || event.target === track) close();
    });

    var closeButton = lightbox.querySelector('.nv-lightbox__button--close');
    var prevButton = lightbox.querySelector('.nv-lightbox__button--prev');
    var nextButton = lightbox.querySelector('.nv-lightbox__button--next');

    if (closeButton) closeButton.addEventListener('click', close);
    if (prevButton) prevButton.addEventListener('click', function () { scrollToSlide(current - 1); });
    if (nextButton) nextButton.addEventListener('click', function () { scrollToSlide(current + 1); });

    document.addEventListener('keydown', function (event) {
      if (lightbox.hidden) return;
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowLeft') scrollToSlide(current - 1);
      if (event.key === 'ArrowRight') scrollToSlide(current + 1);
    });
  }

  /* ------------------------------------------------------------------- tabs */
  function initTabs(root) {
    if (root.dataset.nvReady) return;
    root.dataset.nvReady = 'true';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[role="tabpanel"]'));
    var images = Array.prototype.slice.call(root.querySelectorAll('[data-nv-tab-image]'));

    function select(i) {
      tabs.forEach(function (tab, n) {
        tab.setAttribute('aria-selected', n === i ? 'true' : 'false');
        tab.tabIndex = n === i ? 0 : -1;
      });
      panels.forEach(function (panel, n) { panel.hidden = n !== i; });
      images.forEach(function (image, n) { image.hidden = n !== i; });
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(i); });
      tab.addEventListener('keydown', function (event) {
        var move = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
        if (!move) return;
        event.preventDefault();
        var target = (i + move + tabs.length) % tabs.length;
        select(target);
        tabs[target].focus();
      });
    });

    select(0);
  }

  /* --------------------------------------------------------------- variants */
  function initVariants(form) {
    if (form.dataset.nvReady) return;
    form.dataset.nvReady = 'true';

    var select = form.querySelector('[data-nv-variant-select]');
    var dataEl = form.querySelector('[data-nv-variant-data]');
    if (!select || !dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var root = form.closest('.nv-hero') || form;
    var priceEl = root.querySelector('[data-nv-price]');
    var compareEl = root.querySelector('[data-nv-compare]');
    var submit = form.querySelector('[data-nv-submit]');
    var soldOutLabel = submit ? submit.dataset.soldOutLabel : 'Sold out';
    var defaultLabel = submit ? submit.textContent.trim() : '';

    select.addEventListener('change', function () {
      var variant = variants.filter(function (v) { return String(v.id) === select.value; })[0];
      if (!variant) return;

      if (priceEl) priceEl.textContent = variant.price;
      if (compareEl) {
        var showCompare = variant.compare_at_price && variant.compare_at_price_cents > variant.price_cents;
        compareEl.hidden = !showCompare;
        compareEl.textContent = variant.compare_at_price || '';
      }
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? defaultLabel : soldOutLabel;
      }
    });
  }

  /* ------------------------------------------------------------------- boot */
  function boot(scope) {
    var context = scope || document;
    context.querySelectorAll('.nv-gallery').forEach(initGallery);
    context.querySelectorAll('[data-nv-tabs]').forEach(initTabs);
    context.querySelectorAll('[data-nv-product-form]').forEach(initVariants);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  // Theme editor: sections are swapped in and out of the DOM.
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();